import React from 'react'
import _ from 'lodash'

class ShowTrailerInfo extends React.Component {
	constructor(){
		super()
		this.state ={
			showLessDesc: true
		}
		this.displayCompleteDesc = this.displayCompleteDesc.bind(this)
	}

	ellipsify(str, limit){
		return (
			<div>
				{str.split(' ').slice(0, limit).join(' ')}...<span className="more-button" onClick={this.displayCompleteDesc}>More</span>
			</div>
		)
	}

	displayCompleteDesc(){
		this.setState({
			showLessDesc: false
		})
	}

  renderCreditBlocks() {
    return _.map(this.props.creditBlocks, (c, i) => {
      if (!c.credits)
        return

      return(
        <div className="crew" key={i}>
          <div className="role">{c.title}</div>
          <div className="people">
            {' '}
            { _.map(c.credits, 'title')
            .slice(0, 4)
            .join(', ') }
          </div>
        </div>
      )
    })
  }


	render(){
		return(
			<div className="show__trailer__info">
				<div className="description-container">
					<div className="crew-cast">
            { this.renderCreditBlocks() }
					</div>
					<div className="desc">
					 {(this.props.description && this.props.description.split(' ').length > 30 && this.state.showLessDesc) ?
							this.ellipsify(this.props.description, 30) : this.props.description
					}
					</div>
				</div>
			</div>
		)
	}
}

export default ShowTrailerInfo;
